import type { PlanType } from "api-types/modelTypes";
import type { SalesImage } from "building-types/options/optionSet";
import { SALES_IMAGE_UPLOAD_OPTIONS } from "lib/options/salesImageValidation";
import { uploadImage } from "lib/utils/uploadImage";

interface UploadSalesImageParams {
  planType: PlanType | "catalog";
  planId?: string;
  optionSetId: string;
  optionId: string;
}

export default async function uploadSalesImageToS3({
  planType,
  planId,
  optionSetId,
  optionId,
}: UploadSalesImageParams): Promise<{ salesImage: SalesImage } | null> {
  let s3UploadLocation: string | undefined;
  switch (planType) {
    case "master_plan":
      s3UploadLocation = `master_plans/${planId}/sales_images/${optionSetId}/${optionId}`;
      break;
    case "community_plan":
      s3UploadLocation = `community_plans/${planId}/sales_images/${optionSetId}/${optionId}`;
      break;
    case "lot":
      s3UploadLocation = `lot_community_plans/${planId}/sales_images/${optionSetId}/${optionId}`;
      break;
    case "catalog":
      s3UploadLocation = `catalog/sales_images/${optionSetId}/${optionId}`;
      break;
    default:
      break;
  }

  if (s3UploadLocation) {
    const { url, width, height, filename } = await uploadImage(
      SALES_IMAGE_UPLOAD_OPTIONS,
      undefined,
      ...s3UploadLocation.split("/"),
    );
    return {
      salesImage: {
        title: filename,
        description: "",
        height,
        width,
        url,
      },
    };
  }

  return null;
}
